import '../css/timer.scss'

import { BugsnagErrorBoundary } from './lib/bugsnag' // eslint-disable-line import/order

import { Alert } from '@harvesthq/porchlight'
import debounce from 'debounce'
import { createRoot } from 'preact/compat/client'

import { Header } from './components/Header'
import { SignIn } from './components/SignIn'
import { TimerForm } from './components/TimerForm'
import {
  accessToken,
  currentAccountId as accountId,
  isAuthenticated,
  storeCredentials,
} from './lib/authentication'
import { BroadcastMessageType, broadcastMessage } from './lib/broadcastMessage'
import gtm from './lib/gtm'
import { baseUrl } from './lib/urls'
import {
  extractTimeEntryQueryParams,
  localStorageEnabled,
  postCredentialsToChromeExtension,
  watchForHeightChanges,
} from './lib/util'

function listenForEscapeKey(evt) {
  if (evt.key !== 'Escape') return

  broadcastMessage({ type: BroadcastMessageType.FrameClose, crossOrigin: true })
}

window.addEventListener('resize', debounce(watchForHeightChanges, 100))
document.addEventListener('keyup', watchForHeightChanges)
document.addEventListener('mouseup', watchForHeightChanges)
document.addEventListener('click', watchForHeightChanges)
document.addEventListener('keydown', listenForEscapeKey)

const root = document.getElementById('root')
const searchParams = new URLSearchParams(document.location.search.substring(1))
const chromeless = searchParams.get('chromeless') === 'true'
const closable = searchParams.get('closable') !== 'false'

// TODO: Instead of reloading of the whole page,
// we could set state for the App component of some sort,
// which would re-render everything
window.addEventListener('message', (event) => {
  if (event.origin != baseUrl) return

  if (event.data.type == BroadcastMessageType.AuthSuccess) {
    const { accessToken, accountId, viaSaml } = event.data.value
    storeCredentials(accessToken, accountId, viaSaml)

    window.location.reload()
  }
})

function renderInErrorBoundary(children) {
  if (root === null) return
  // TODO Add FallbackComponent={ErrorComponent} prop to BugsnagErrorBoundary
  // so that we can render an error message if React fails to render children
  createRoot(root).render(
    BugsnagErrorBoundary ? (
      <BugsnagErrorBoundary>{children}</BugsnagErrorBoundary>
    ) : (
      children
    )
  )
  setTimeout(watchForHeightChanges, 0)
}

if (!isAuthenticated()) {
  gtm()
  renderInErrorBoundary(
    <>
      {!chromeless && <Header />}
      {localStorageEnabled || (
        <Alert
          className="pds-m-md pds-mb-xs"
          dismissable={false}
          variant="danger"
        >
          Please make sure that third-party cookies are permitted or that
          harvestapp.com and platform.harvestapp.com appear in your whitelist.
        </Alert>
      )}
      <SignIn />
    </>
  )
} else {
  if (accessToken && accountId) {
    postCredentialsToChromeExtension(accessToken, accountId)
  }

  renderInErrorBoundary(
    <TimerForm
      defaultProjectCode={searchParams.get('default_project_code')}
      defaultProjectName={searchParams.get('default_project_name')}
      closable={closable}
      chromeless={chromeless}
      params={extractTimeEntryQueryParams(searchParams)}
    />
  )
}
